export default __webpack_public_path__ + "static/media/sico_saint-paul-saint-louis.58b0de51.jpg";